import { objectWithoutKeys } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { FeedLoadFulfilledAction, FeedLoadPendingAction } from '../../domains/feedLoad/actions.types';
import {
  FeedThreadCountsOnServerClearAction,
  FeedThreadCountsOnServerIncrementAction,
  FeedThreadstarterCountsOnServerClearAction,
} from '../../domains/feedRealtime/actions.types';
import { Feed, Message, Thread } from '../types';

import { FeedWithNewerMessagesOnServer, RealtimeFeedNewerMessagesOnServer } from './types';

export type RealtimeFeedThreadNewerMessagesAction =
  | FeedThreadCountsOnServerClearAction
  | FeedThreadCountsOnServerIncrementAction
  | FeedThreadstarterCountsOnServerClearAction
  | FeedLoadPendingAction
  | FeedLoadFulfilledAction;

const incrementFeedThreadCount = (
  state: RealtimeFeedNewerMessagesOnServer,
  feedId: Feed['id'],
  threadId: Thread['id'],
  messageId: Message['id'],
  isThreadStarter: boolean
) => {
  const feed: FeedWithNewerMessagesOnServer = state[feedId] || {
    messageIds: [],
    threadstarterThreadIds: [],
  };

  const newThreadstarterThreadIds: Thread['id'][] = isThreadStarter
    ? Array.from(new Set([...feed.threadstarterThreadIds, threadId]))
    : feed.threadstarterThreadIds;
  const newMessageIds: Message['id'][] = Array.from(new Set([...feed.messageIds, messageId]));

  return {
    ...state,
    [feedId]: {
      messageIds: newMessageIds,
      threadstarterThreadIds: newThreadstarterThreadIds,
    },
  };
};

const removeFeed = (state: RealtimeFeedNewerMessagesOnServer, feedId: Feed['id']) => objectWithoutKeys(state, [feedId]);

const removeFeedThreadstarterCounts = (state: RealtimeFeedNewerMessagesOnServer, feedId: Thread['id']) => {
  if (!state[feedId]) {
    return state;
  }

  return {
    ...state,
    [feedId]: {
      ...state[feedId],
      threadstarterThreadIds: [],
    },
  };
};

const initialState: RealtimeFeedNewerMessagesOnServer = {};

const reducer: Reducer<RealtimeFeedNewerMessagesOnServer, RealtimeFeedThreadNewerMessagesAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FEED_THREAD_COUNTS_ON_SERVER.CLEAR':
      return removeFeed(state, action.payload.feedId);
    case 'FEED_THREAD_COUNTS_ON_SERVER.INCREMENT':
      return incrementFeedThreadCount(
        state,
        action.payload.feedId,
        action.payload.threadId,
        action.payload.messageId,
        action.payload.isThreadStarter
      );
    case 'FEED_THREADSTARTER_COUNTS_ON_SERVER.CLEAR':
      return removeFeedThreadstarterCounts(state, action.payload.feedId);
    case 'FEED.LOAD_PENDING':
      return removeFeed(state, action.payload.id);
    case 'FEED.LOAD_FULFILLED':
      return removeFeed(state, action.payload.id);
    default:
      return state;
  }
};

export default reducer;
